import useBreakpoints from "ui-library/theme/breakpoints";

export const useGetFieldDirection: () => "row" | "column" = () => {
  const isBreakMD = useBreakpoints("md");
  return isBreakMD ? "row" : "column";
};
